import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router-dom";

import { reviewApi } from "../api/review";
import { AiSummary } from "./AiSummary";
import { CandidateFunnel } from "./CandidateFunnel";
import { DecisionForm } from "./DecisionForm";
import { ReviewerGate } from "./ReviewerGate";
import { Answers, Checks, Curiosity, Flags, Fluency, Header, Profile, Timeline } from "./sections";

function Candidate({ publicId }: { publicId: string }) {
  const review = useQuery({
    queryKey: ["review", "candidate", publicId],
    queryFn: () => reviewApi.candidate(publicId),
    retry: false,
    // An `auto` summary is generated in the background: poll until it settles.
    refetchInterval: (query) => (query.state.data?.summary?.status === "generating" ? 4000 : false),
  });
  if (review.isPending) return <main className="page wide">Loading…</main>;
  if (review.isError) {
    return (
      <main className="page wide">
        <p role="alert">{review.error.message}</p>
      </main>
    );
  }
  const r = review.data;
  return (
    <main className="page wide review">
      <p>
        <Link to="/review">← Queue</Link>
      </p>
      <Header review={r} />
      {!r.submitted && (
        <p className="notice" role="status">
          Not submitted yet. This is what's recorded so far; flags, the AI summary and decisions
          appear once the candidate submits.
        </p>
      )}
      <CandidateFunnel review={r} />
      {r.submitted && <Flags flags={r.flags} />}
      <Answers review={r} />
      <Fluency fluency={r.fluency ?? null} review={r} />
      <Curiosity review={r} />
      <Profile review={r} />
      <Checks review={r} />
      <Timeline review={r} />
      {r.submitted && <AiSummary review={r} />}
      {r.submitted && <DecisionForm review={r} />}
    </main>
  );
}

export function CandidatePage() {
  const { publicId = "" } = useParams();
  return (
    <ReviewerGate>
      <Candidate publicId={publicId} />
    </ReviewerGate>
  );
}
